export enum RemoteDiagnosticsConnectionReasons {
  INSTALLER_SUPPORT = 'INSTALLER_SUPPORT',
  CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT',
}

export enum RemoteDiagnosticsConnectionReasonsControls {
  ReasonType = 'reasonType',
  TicketNumber = 'ticketNumber',
  DescriptionText = 'descriptionText',
}

export interface ConnectionReasonFormModelValue {
  [RemoteDiagnosticsConnectionReasonsControls.ReasonType]: string | null;
  [RemoteDiagnosticsConnectionReasonsControls.TicketNumber]?: string;
  [RemoteDiagnosticsConnectionReasonsControls.DescriptionText]?: string;
}
